<template>
  <card class="card-stats" :show-footer-line="true">
    <b-row class="justify-content-between">

      <b-col class="pr-0" cols="auto" v-if="$slots.icon || icon">
        <slot name="icon">
          <div class="icon icon-shape text-white rounded-circle shadow" :class="[`bg-${type}`, iconClasses]">
            <i :class="icon"></i>
          </div>
        </slot>
      </b-col>

      <b-col>
        <slot>
          <h5 class="card-title text-uppercase text-muted mb-0" v-if="title">{{ title }}</h5>
          <span 
            class="h2 font-weight-bold mb-0"
            :class="{ 'mr-2': hasIndicatorBadge }"
            :style="{ cursor: copyToClipboard ? 'pointer' : 'default'}" 
            v-if="subTitle" 
            v-on:click="copyToClipboard ? copyText() : () => {}"
          >
            {{ subTitle }}
          </span>
          <simple-status-block v-if="hasIndicatorBadge" :organisation="organisation" :isBiosecurity="isBiosecurity === 'yes'"/>
          <span v-if="copyToClipboard"><i class="fas fa fa-copy ml-2 dz-clickable" style="cursor: pointer;" v-on:click="copyText"/></span>
        </slot>
      </b-col>

      <b-col align="right" v-if="$slots.actions">
          <div>
            <base-dropdown menuClasses="dropdown-menu-right">
                <base-button slot="title" type="neutral" class="dropdown-toggle">
                    <i class="fas fa fa-ellipsis-v"></i>
                </base-button>
                <slot name="actions"></slot>
            </base-dropdown>
          </div>
      </b-col>


    </b-row>

    <p class="mt-3 mb-0 text-sm">
      <slot name="footer"> </slot>
    </p>

    <slot name="append"></slot>
  </card>
</template>
<script>
import Card from './Card.vue';
import SimpleStatusBlock from '../Simple/SimpleStatusBlock.vue'

export default {
  name: 'stats-card',
  components: {
    Card,
    SimpleStatusBlock
  },
  props: {
    type: {
      type: String,
      default: 'primary'
    },
    icon: String,
    title: String,
    subTitle: String,
    iconClasses: [String, Array],
    copyToClipboard: Boolean,
    organisation: Object,
    isBiosecurity: String
  },
  computed: {
    hasIndicatorBadge() {
      const hasKeys = !!Object.keys(this.organisation || this.isBiosecurity || {}).length || this.isBiosecurity === 'yes';
      return hasKeys
    }
  },
  methods: {
    copyText: async function () {
      try {
        await navigator.clipboard.writeText(this.subTitle);
        this.success("Successfully copied to clipboard");
      } catch($e) {
        console.log('Cannot copy', $e);
      }
    },
    success: function (message) {
      this.$notify({
        title: `Location Copied!`,
        message: `${message}`,
        type: 'info',
        duration: 2000
      });
    },
  }
};
</script>
<style></style>
